enum InputType {
  Text = 'text',
  Number = 'number',
  Date = 'date'
}

export default InputType;
